import { render, staticRenderFns } from "./Micromall.vue?vue&type=template&id=7db4012e&scoped=true"
import script from "./Micromall.vue?vue&type=script&lang=js"
export * from "./Micromall.vue?vue&type=script&lang=js"
import style0 from "./Micromall.vue?vue&type=style&index=0&id=7db4012e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db4012e",
  null
  
)

export default component.exports